<template>
    <div class="absolute pin flex flex-col justify-center items-center" v-if="portraitMode">
        <svg class="text-blue-lightest w-16 mb-8" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.265 28.265"><path d="M14.133 28.265c-7.061 0-12.805-5.75-12.805-12.809 0-7.06 5.744-12.807 12.805-12.807.469 0 .943.027 1.414.08V.659a.67.67 0 0 1 .406-.611.67.67 0 0 1 .723.148l4.537 4.547a.658.658 0 0 1 0 .932l-4.535 4.557a.669.669 0 0 1-.725.143.669.669 0 0 1-.406-.609V7.47a7.825 7.825 0 0 0-1.414-.125c-4.473 0-8.113 3.639-8.113 8.111 0 4.471 3.641 8.113 8.113 8.113s8.111-3.643 8.111-8.113c0-.363.295-.66.662-.66h3.369c.365 0 .662.297.662.66 0 7.059-5.748 12.809-12.804 12.809z"/></svg>
        <p class="text-blue-lightest">Please rotate your device</p>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                portraitMode: false
            }
        },

        mounted() {
            this.checkOrientation()

            document.addEventListener('orientationchange', this.checkOrientation)
        },

        beforeDestroy() {
            document.removeEventListener('orientationchange', this.checkOrientation)
        },

        methods: {
            checkOrientation() {
                this.portraitMode = window.innerWidth > window.innerHeight ? false : true
            },
        }
    }
</script>
